import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/(site)/pengumuman/page.tsx");
